var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 18,
    viewBox: "0 0 32 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19196 0.892715C0.458484 1.62102 0.458484 2.82535 1.19196 3.55365L14.918 17.1824C15.2721 17.5341 15.7721 17.7329 16.2577 17.7329C16.7386 17.7329 17.218 17.5591 17.5974 17.1824L31.3043 3.57149C32.0722 2.85389 32.082 1.62102 31.3485 0.892715C30.615 0.164414 29.4021 0.164414 28.6686 0.892715L16.2818 13.2158L3.87083 0.892715C3.50383 0.528312 3.01418 0.342285 2.53168 0.342285C2.04865 0.342285 1.55847 0.528817 1.19196 0.892715V0.892715Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.2fc54609d559e28a8b8838237db7bdac.svg";
export { ForwardRef as ReactComponent };